import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import qs from 'qs'
import Paging from '../../components/Paging'
import ModalHelp from "../../components/ModalHelp";

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            dataKelas    : [],
            kelas_id     : 0,
            pageCount    : 0,
            currentPage  : 0,
            tutorial: '',
            isModalHelpShow  : false,
            isLoading    : false,
            isModalShow  : false,
        }

        this.toggleModal              = this.toggleModal.bind(this)
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }

    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/HaI3LajFcng'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    handleSubmitDeleteButton() {

        Alert.error("BELUM ADA APINYA");
        
        this.toggleModal()

        // axios({
        //     method: 'get',
        //     url: '/produk/deleteProduk/' + this.state.id_produk
        // })
        //     .then(response => {

        //         Alert.success("Data berhasil dihapus");
        //         this.loadData();
        //         this.toggleModal();

        //         return;
        //     })
        //     .catch(error => {
        //         console.log(error)
        //         this.setState({ isLoading: false })
        //         Alert.error("Gagal terhubung ke server!")
        //     })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1
        })
        
        axios({
            method: 'post',
            url: '/kelas?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {
                
                this.setState({
                    dataKelas: result.data.data,
                    pageCount: result.data.last_page,
                    isLoading: false 
                })
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    componentDidMount() {
                
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
        this.loadData()        
    }

    render () {

        return (         
            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-block">
                        <NavLink 
                            to={`${this.props.match.url}/add`} 
                            className="btn btn-primary"
                        >
                            Tambah Kelas
                        </NavLink>

                        <NavLink 
                            to={`${this.props.match.url}/listwali`} 
                            className="btn btn-primary"
                            style={{marginLeft:10}}
                        >
                            Wali Kelas
                        </NavLink>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Data Kelas
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataKelas.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Nama Kelas</th>
                                                    <th>Jam Masuk</th>
                                                    <th>Tingkat Kelas</th>
                                                    <th>Status Aktif</th>
                                                    <th width="200">Opsi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {                                                    
                                                    this.state.dataKelas.map((item, i) => {
                                                        return (
                                                            <tr key={i++}>
                                                                <td>{i++}</td>
                                                                <td>{item.kelas_nama}</td>
                                                                <td>
                                                                    {item.shift ? <span className="badge badge-primary">{item.shift.name}</span> : <span className="badge badge-danger">Not Set</span>}
                                                                </td>
                                                                <td>{item.kelas_level}</td>
                                                                <td>
                                                                    {
                                                                        item.kelas_status === "1" ? "Aktif" : "Non Aktif"
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <NavLink to={`${this.props.match.url}/edit/${item.kelas_id}`} className="btn btn-secondary btn-sm">
                                                                        Edit
                                                                    </NavLink>
                                                                    &nbsp;&nbsp;
                                                                   
                                                                    <NavLink to={`${this.props.match.url}/media/${item.kelas_id}`} className="btn btn-secondary btn-sm">
                                                                        Lihat Siswa
                                                                    </NavLink>
                                                                    
                                                                    {/* 
                                                                        <button
                                                                        type="button"
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => {
                                                                            this.toggleModal();
                                                                            this.setState({ kelas_id: item.kelas_id });
                                                                        }}
                                                                    >
                                                                        Hapus
                                                                    </button> */}
                                                                </td>                                                                                                                 
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>   

                                        <Paging
                                            handlePageClick={this.handlePageClick.bind(this)}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>                   
        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Kelas/Lists.js